
    import "src/shared/components/ProfileForm/index.module.scss?farm_css_modules";
    
    export default {"btn": `btn-b1feeae4`,"form": `form-b1feeae4`,"formComponent": `formComponent-b1feeae4`,"input": `input-b1feeae4`,"rightFormComponent": `rightFormComponent-b1feeae4`,"selectDescription": `selectDescription-b1feeae4`}
    